




























































































import Vue, { PropType } from 'vue';
import NPNumberRange from '@/components/NPNumberRange.vue';
import NpSelect from '@/components/NpSelect.vue';
import MetaFields from '@/models/MetaFields';
import NpInput from '@/components/NpInput.vue';
import NpCheckbox from '@/components/NpCheckbox.vue';


export default Vue.extend({
	name: 'MetaFieldForm',
	inject: ['$validator'],
	components: {
		NpInput,
		NpSelect,
		NpCheckbox,
	},

	props: {
		value: Object as PropType<{ [prop: string]: MetaFields }>,
		available_fields: Object as any,
		count: Number,
	},

	data() {
		return {
			meta_fields: {} as { [prop: string]: MetaFields },
		};
	},

	computed: {
		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},
	},

	watch: {
		meta_fields() {
			this.$emit('input', this.value);
		},
	},

	mounted() {
		this.meta_fields = this.value;
	},

	methods: {
		checkbox_change(id: any) {
			if (this.meta_fields[id].value === true) {
				this.meta_fields[id].value = false;
			} else {
				this.meta_fields[id].value = true;
			}
		},
	},
});
